
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in-app-orders",
      function () {
        return require("private-next-pages/in-app-orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in-app-orders"])
      });
    }
  